import React from "react";

import './styles.scss';

export default ({open, closeDrawer, children}) => (
  <div className={['drawer', open && 'open'].join(' ')}>
    <div
      className="drawer__background"
      onClick={closeDrawer}
    />
    <div className="drawer__content">
      {children}
    </div>
  </div>
)
